import type { FunctionComponent } from 'react';
import { Container, Main } from '@media-ui/core/src/components/Layout';
import Wrapper from '@media-ui/core/src/components/Wrapper';
import classNames from 'classnames';
import * as s from './Page.css';
import * as T from './Page.types';
const Page: FunctionComponent<T.IPageProps> = (props) => {
    const { children, sidebar, isWrapper, content, className, hideTopSpacing } = props;
    const renderContent = () => {
        if (content) {
            return <>{content}</>;
        }
        return <>{children}</>;
    };
    if (sidebar) {
        return (<div className={classNames(className, s.root, {
                [s.hideTopSpacing]: hideTopSpacing,
            })}>
        <Wrapper dataQaDetail="ContentLayout">
          <Container>
            <Main>{renderContent()}</Main>
            {sidebar}
          </Container>
        </Wrapper>
      </div>);
    }
    if (isWrapper) {
        return (<div className={classNames(className, s.root, {
                [s.hideTopSpacing]: hideTopSpacing,
            })}>
        <Wrapper dataQaDetail="ContentLayout">{renderContent()}</Wrapper>
      </div>);
    }
    return (<div className={classNames(className, s.root, {
            [s.hideTopSpacing]: hideTopSpacing,
        })}>
      {renderContent()}
    </div>);
};
export default Page;
